export default __webpack_public_path__ + "static/media/404-bg.dd080258.jpg";